import { RpmMonitoringUnifyContentPackageType } from '../types/RpmMonitoringContentModel';

export const RpmMonitoringContentMock: RpmMonitoringUnifyContentPackageType = {
  rpm_monitoring: [
    {
      metadata: {},
      title: '[M]title',
      rpm_tab: '[M]rpm_tab',
      rpm_module: [
        {
          rpm_module: {
            metadata: {},
            algorithm_code: '[M]rpm_module.rpm_module.algorithm_code',
            header: '[M]rpm_module.rpm_module.header',
            details_header: '[M]rpm_module.rpm_module.details_header',
            disclaimer_md: '[M]rpm_module.rpm_module.disclaimer_md',
            learn_more: [
              {
                header_and_body: {
                  metadata: {},
                  header: '[M]rpm_module.rpm_module.learn_more.header_and_body.header',
                  body_text_md: '[M]rpm_module.rpm_module.learn_more.header_and_body.body_text_md',
                },
              },
              {
                header_body_icon: {
                  metadata: {},
                  header: '[M]rpm_module.rpm_module.learn_more.header_body_icon.header',
                  body_text: [
                    {
                      body: {
                        metadata: {},
                        body_text_md:
                          '[M]rpm_module.rpm_module.learn_more.header_body_icon.body_text.body.body_text_md',
                        icon: 'notification',
                      },
                    },
                  ],
                },
              },
            ],
            cards: [
              {
                card: {
                  metadata: {},
                  code: '[M]rpm_module.rpm_module.cards.card.code',
                  charts: [
                    {
                      chart: {
                        metadata: {},
                        title: '[M]rpm_module.rpm_module.cards.card.charts.chart.title',
                        code: '[M]rpm_module.rpm_module.cards.card.charts.chart.code',
                        not_reported_label: '[M]rpm_module.rpm_module.cards.card.charts.chart.not_reported_label',
                        parameters: [
                          {
                            metadata: {},
                            label: '[M]rpm_module.rpm_module.cards.card.charts.chart.parameters.label',
                            parameter: [
                              {
                                metadata: {},
                                title: '[M]rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.title',
                                code: '[M]rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.code',
                                label: '[M]rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.label',
                                secondary_label:
                                  '[M]rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.secondary_label',
                                tertiary_label:
                                  '[M]rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.tertiary_label',
                                tooltip_label:
                                  '[M]rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.tooltip_label',
                                details_label:
                                  '[M]rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.details_label',
                                uid: '[M]rpm_module.rpm_module.cards.card.charts.chart.parameters.parameter.uid',
                                _content_type_uid: 'rpm_parameter',
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
      study_day_label: '[M]study_day_label',
      uid: '[M]uid',
      _content_type_uid: 'rpm_monitoring',
    },
  ],
};
